var _circle, _line, _line2, _line3, _line4, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersTarget(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 88
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 16,
    x2: 128,
    y2: 56
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 200,
    x2: 128,
    y2: 240
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 128,
    x2: 56,
    y2: 128
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 128,
    x2: 240,
    y2: 128
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 118,
    r: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,170a40,40,0,0,1,72,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146,100a20,20,0,1,1,8,38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160,150a40,40,0,0,1,28,18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTarget);
export default __webpack_public_path__ + "static/media/users-target.d09994594dd8a41286dc26ea30c34aec.svg";
export { ForwardRef as ReactComponent };